import { tr } from "@common/utils/i18n";
import { translationsEN } from "../translations/en";

export const trDts = tr<keyof typeof translationsEN>;
